import * as React from "react";

export default class EntitiesList extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            selected: null,
            loading: false
        }
    }

    getSelected = () =>
    {
        return this.state.selected;
    }

}